export default __webpack_public_path__ + "static/media/potential--1.132ddfad.png";